import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    DestroyRef,
    inject,
    OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { NavigationService } from 'app/@core/navigation/navigation.service';

@Component({
    selector: 'mobile-tab-bar',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterLink, RouterLinkActive, MatIconModule],
    templateUrl: './mobile-tab-bar.component.html',
})
export class MobileTabBarComponent implements OnInit {
    tabItems: FuseNavigationItem[] = [];

    private _nav      = inject(NavigationService);
    private _cdr      = inject(ChangeDetectorRef);
    private _destroyRef = inject(DestroyRef);

    ngOnInit(): void {
        this._nav.navigation$
            .pipe(takeUntilDestroyed(this._destroyRef))
            .subscribe(nav => {
                this.tabItems = this._extractTabItems(nav.default);
                this._cdr.detectChanges();
            });
    }

    private _extractTabItems(items: FuseNavigationItem[]): FuseNavigationItem[] {
        const result: FuseNavigationItem[] = [];
        for (const item of items) {
            if (item.type === 'basic') {
                result.push(item);
            } else if (item.children?.length) {
                result.push(...this._extractTabItems(item.children));
            }
        }
        return result;
    }
}
